/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Overview_OpenInputs */

const vi_camera_overview_open = /** @type {(inputs: Camera_Overview_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách camera`)
};

/**

* @param {Camera_Overview_OpenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_overview_open = /** @type {((inputs?: Camera_Overview_OpenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Overview_OpenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_overview_open(inputs)
});